<template>
    <div>
        <el-tabs>
            <!-- <el-tab-pane label="第一/二季度证书">
                <el-button type="primary" @click="exportPDF('showTotal')" size="medium" style="margin:5px;">导出PDF</el-button>
                

                <div id="showTotal">
                    <div v-for="(item,index) in event_awards" :key="index" >
                       
                        <div v-if="item.award_saiji_num ? false : true" class="certContainer4">

                            <img
                            src="../../assets/felc_cer.png"
                            class="model"
                            />
                            
                            <div class="ziZm">兹证明</div>

                            
                            <div class="event">{{ item.project_name}}</div>

                            <div class="projectName">{{ item.application_event }}</div>

                            <div class="award">{{ item.award_show_lable }}</div>

                            <div class="awardPh">{{'('+ item.percent_lable + ')'}}</div>

                            <div class="student">
                            <span class="name">{{ item.student.student_lastName + item.student.student_givenName }}</span>
                            </div>
                            <div class="school">{{ item.account.account_name }}</div>

                            <div class="email">{{ item.student.student_email }}</div>

                            <div class="rhZm">荣获</div>

                            <img class="saiquImg" v-if="item.group_name == '92赛区'" src="../../assets/felc-92赛区.png">
                            <img class="saiquImg" v-if="item.group_name == 'FE赛区'" src="../../assets/felc-FE赛区.png">
                            <img class="saiquImg" v-if="item.group_name == '标准赛区'" src="../../assets/felc-标准赛区.png">
                            <img class="saiquImg" v-if="item.group_name == 'BFA赛区'" src="../../assets/felc-BFA赛区.png">
                            <img class="saiquImg" v-if="item.group_name == '国际赛区'" src="../../assets/felc-国际赛区.png">
                            <img class="saiquImg" v-if="item.group_name == '职教赛区'" src="../../assets/felc-职教赛区.png">



                            <div class="tefaLab">特发此证，以资鼓励。</div>

                            <div class="timeLab">{{'颁发日期：' + item.show_time}}</div>

                        </div>

                    </div>
                </div>
            </el-tab-pane> -->

          
            <!-- <el-tab-pane label="第三季度证书">

                <el-button type="primary" @click="exportPDF('showTranscript')" size="medium">导出pdf</el-button>

                <div id="showTranscript" v-if="project_code == '23-24FELC' && type != 'adviser'">

                    <div v-for="(item,index) in event_awards" :key="index" >


                    <div v-if="item.award_saiji_num ? true : false" class="certContainerFelc">

                        <img
                            src="../../assets/felc_cer_new.jpg"
                            class="model"
                            />

                        <div class="school">{{ item.account.account_name }}</div>
                        <div class="student">
                        <span class="name">{{ item.student.student_lastName + item.student.student_givenName }}</span>
                        </div>
                        <div class="email">{{ item.student.student_email }}</div>


                        <div class="tefaLab">FELC未来企业菁英</div>

                        <div class="projectName">{{ item.award_show_project_name }}</div>

                        <div class="event">{{ item.application_event }}</div>

                        

                        <div class="award">{{ item.award_show_lable }}</div>

                        <div class="awardPh">{{'('+ item.percent_lable + ')'}}</div>

                        

                        

                        <img class="saiquImg" v-if="item.group_name == '92赛区'" src="../../assets/felc-92赛区.png">
                        <img class="saiquImg" v-if="item.group_name == 'FE赛区'" src="../../assets/felc-FE赛区.png">
                        <img class="saiquImg" v-if="item.group_name == '标准赛区'" src="../../assets/felc-标准赛区.png">
                        <img class="saiquImg" v-if="item.group_name == 'BFA赛区'" src="../../assets/felc-BFA赛区.png">
                        <img class="saiquImg" v-if="item.group_name == '国际赛区'" src="../../assets/felc-国际赛区.png">
                        <img class="saiquImg" v-if="item.group_name == '职教赛区'" src="../../assets/felc-职教赛区.png">


                        <div class="timeLab">{{item.show_time}}</div>


                    </div>


                    </div>


                </div>

            </el-tab-pane> -->

            <el-tab-pane label="中文证书">

              <el-button type="primary" @click="exportPDF('showTranscript')" size="medium">
                {{ isBatchExport ? '导出ZIP' : '导出PDF' }}
              </el-button>

              <div id="showTranscript">

                  <div v-for="(item,index) in event_awards" :key="index" >


                  <div class="certContainerFelc" :data-file-name="getCertificateFileName(item, index, '中文证书')">

                      <img
                          src="../../assets/felc_cer_new.jpg"
                          class="model"
                          />

                      <div class="school">{{ item.account.account_name }}</div>
                      <div class="student">
                      <span class="name">{{ item.student.student_lastName + item.student.student_givenName }}</span>
                      </div>
                      <div class="email">{{ item.student.student_email }}</div>


                      <div class="tefaLab">FEL未来企业菁英</div>

                      <div class="projectName">{{ getCompetitionName(item) }}</div>

                      <div class="event">{{ item.application_event }}</div>

                      

                      <div class="award">{{ item.award_show_lable }}</div>

                      <!-- <div class="awardPh">{{'('+ item.percent_lable + ')'}}</div> -->

                      

                      

                      <img class="saiquImg" v-if="item.group_name == '92赛区'" src="../../assets/felc-92赛区.png">
                      <img class="saiquImg" v-if="item.group_name == 'FE赛区'" src="../../assets/felc-FE赛区.png">
                      <img class="saiquImg" v-if="item.group_name == '标准赛区'" src="../../assets/felc-标准赛区.png">
                      <img class="saiquImg" v-if="item.group_name == 'BFA赛区'" src="../../assets/felc-BFA赛区.png">
                      <img class="saiquImg" v-if="item.group_name == '国际赛区'" src="../../assets/felc-国际赛区.png">
                      <img class="saiquImg" v-if="item.group_name == '职教赛区'" src="../../assets/felc-职教赛区.png">

                      
                      <div class="timeLab" v-if="item.issue_date">{{ formatIssueDate(item.issue_date *1000) }}</div>
                      <div class="timeLab" v-else>{{ defaultIssueDateZh(item.quarter) }}</div>

                  </div>


                  </div>


              </div>

            </el-tab-pane>
            <el-tab-pane label="英文证书">

              <el-button type="primary" @click="exportPDF('showTranscriptEng')" size="medium">
                {{ isBatchExport ? '导出ZIP' : '导出PDF' }}
              </el-button>

              <div id="showTranscriptEng">

                  <div v-for="(item,index) in event_awards" :key="index" >


                  <div class="certContainerFelcEng" :data-file-name="getCertificateFileName(item, index, '英文证书')">

                      <img
                          src="../../assets/felc_cer_english.jpg"
                          class="model"
                          />

                      <div class="recipientInfo">
                        <div class="school" :class="{ 'is-long': isLongCertificateText(getAccountNameEn(item), 64) }">{{ getAccountNameEn(item) }}</div>
                        <div class="student" :class="{ 'is-long': isLongCertificateText(formatStudentName(item.student), 28) }">
                        <span class="name">{{ formatStudentName(item.student) }}</span>
                        </div>
                        <div class="email">{{ item.student.student_email }}</div>
                      </div>

                      <div class="tefaLab">Future Enterprise Leaders</div>

                      <div class="projectName">{{ getCompetitionNameEn(item) }}</div>
                      <!-- <div class="event">{{ 'FMCG (Fast-Moving Consumer Goods) Industry Management' }}</div> -->

                      <div class="event">{{ item.application_event }}</div>
                      <div class="award">{{ getAwardLabelEn(item) }}</div>
                      <img class="saiquImg" v-if="item.group_name == '92赛区'" src="../../assets/felc-92赛区.png">
                      <img class="saiquImg" v-if="item.group_name == 'FE赛区'" src="../../assets/felc-FE赛区.png">
                      <img class="saiquImg" v-if="item.group_name == '标准赛区'" src="../../assets/felc-标准赛区.png">
                      <img class="saiquImg" v-if="item.group_name == 'BFA赛区'" src="../../assets/felc-BFA赛区.png">
                      <img class="saiquImg" v-if="item.group_name == '国际赛区'" src="../../assets/felc-国际赛区.png">
                      <img class="saiquImg" v-if="item.group_name == '职教赛区'" src="../../assets/felc-职教赛区.png">
                      <div class="timeLab" v-if="item.issue_date">{{ formatIssueDateEnglish(item.issue_date * 1000) }}</div>
                      <div class="timeLab" v-else>{{ defaultIssueDateEn(item.quarter) }}</div>
                  </div>
                  </div>
              </div>
            </el-tab-pane>           
            <!-- <el-tab-pane label="成绩单">
                <el-button type="primary" @click="exportPDF('showTranscript')" size="medium" style="margin:5px;">导出PDF</el-button>

                <div id="showTranscript">
                    <div v-for="(item,index) in transcripts" :key="index" class="transcriptContainer" style="margin-bottom:10px;">
                        <img src="../../assets/transcript_felc.jpg" class="model_p"/>
                        <div class="name">{{upfirstName(item.student_info.student_givenName_pinyin) + ' ' + upfirstName(item.student_info.student_lastName_pinyin) + ' ' + item.student_info.student_lastName + ' ' + item.student_info.student_givenName}}</div>
                        <div class="info">
                            <div>
                                <span class="tag">邮箱: </span>
                                <span class="content">{{item.student_info.student_email}}</span> | 
                                <span class="tag">性别: </span>
                                <span class="content">{{item.student_info.student_gender == '男'? '男' : '女'}}</span> | 
                                <span class="tag">预计毕业年份: </span>
                                <span class="content">{{item.student_info.student_graduation}}</span>
                            </div>
                            <div style="margin-top:6px">
                                <span class="tag">学校: </span>
                                <span class="content">{{item.account_info.account_name}}</span>
                            </div>
                        </div>
                        
                        <div class="score1" >
                            <div  v-for="score in item.score_info" :key="score._id.$id">
                                <div  v-if="score.score_type == 'personal'" style="margin-bottom:20px;">
                                    <div class="title">{{score.application_event + ' - ' + '客观笔试'}}</div>
                                    <div style="margin-top:5px">分数:<span>{{score.total_score}}</span>/{{score.full_score}} ></div>  
                                </div>
                            </div>
                        </div>

                        <div class="time1">{{'2023年4月3日'}}</div>


                    </div>
                </div>
            </el-tab-pane> -->
        </el-tabs>
    </div>
</template>

<script>
import { getEducatorAwardStudents, getStudentAwards,getStudentTranscripts} from '../../api/index.js'
import {getUserId,getProjectCode} from '../../utils/store'
import {formatDate} from '../../utils/date'
import {
  downloadPdfForElements,
  downloadPdfZipForElements,
  sanitizeFileName
} from '../../utils/pdfExport'

export default {
  name: 'awardfbla',
  data () {
    return {
        project_code:getProjectCode(),
        total_awards: [],
        event_awards: [],
        completes: [],
        transcripts:[],
        type:'all',
        id:'',
        award_create_time:'2022年12月10日',
        award_type_label_arr:{
            'personal total':'Individual Total Score Rank',
            'event rank':'Individual Event Rank',
            'event team rank':'Team Event Rank'
        },
        direction:1

    }
  },
  mounted () {

    this.type = this.$route.query.type
    this.id = this.$route.query.id

    this.fetchData()
  },
  computed: {
    schoolYear() {
      const m = (this.project_code || '').match(/^(\d{2})-(\d{2})/)
      return m ? `${m[1]}-${m[2]}` : ''
    },
    schoolYearEndFull() {
      const m = (this.project_code || '').match(/^(\d{2})-(\d{2})/)
      return m ? `20${m[2]}` : ''
    },
    isBatchExport() {
      if (this.$route.query.teacher_all) return true
      return Boolean(this.$route.query.student_ids)
    }
  },
  methods: {
    defaultIssueDateZh(quarter) {
      const yearEnd = this.schoolYearEndFull
      if (!yearEnd) return ''
      if (quarter === 'three') return `${yearEnd}年5月29日`
      if (quarter === 'two') return `${yearEnd}年5月5日`
      return `${yearEnd}年4月3日`
    },
    defaultIssueDateEn(quarter) {
      const yearEnd = this.schoolYearEndFull
      if (!yearEnd) return ''
      if (quarter === 'three') return `May 29, ${yearEnd}`
      if (quarter === 'two') return `May 5, ${yearEnd}`
      return `April 3, ${yearEnd}`
    },
    getCompetitionName(item) {
      if (!item) return ''
      const dataCompetitionName = item.competition_name ||
        item.contest_name ||
        item.award_competition_name ||
        item.competitionName ||
        item.contestName ||
        item['竞赛名称'] ||
        item.project_name
      if (dataCompetitionName) return dataCompetitionName

      const subject = String(item.application_event || '')
      const schoolYearText = this.schoolYear ? `${this.schoolYear}学年` : ''
      const academicSubjects = ['经济学', '创业与中小企业管理（专业）', '国际商业（专业）']
      const enterpriseSubjects = ['会计学（通用）', '商业决策', '数字表格', '销售管理', '国际商业（通用）', '市场营销', '数字营销', '数据分析', '组织管理', '组织领导力', '快速消费品行业管理']

      if (academicSubjects.some((name) => subject.indexOf(name) !== -1)) {
        return `${schoolYearText}高校"商科学术"竞赛`
      }
      if (enterpriseSubjects.some((name) => subject.indexOf(name) !== -1)) {
        return `${schoolYearText}高校"企业技能"竞赛`
      }

      return item.competition_name || item.contest_name || item.award_show_project_name || item.project_name || ''
    },
    getCompetitionNameEn(item) {
      if (!item) return ''
      const dataCompetitionNameEn = item.competition_name_en ||
        item.project_name_en ||
        item.award_competition_name_en ||
        item.competitionNameEn ||
        item.contestNameEn ||
        item.project_nameEn
      if (dataCompetitionNameEn) return dataCompetitionNameEn

      const competitionText = [
        this.getCompetitionName(item),
        item.application_event,
        item.application_eventEn,
        item.award_show_project_name,
        item.project_name,
        item.project_name_en,
        item.competition_name_en,
        item.project_nameEn
      ].filter((name) => name).join(' ')
      const academicKeywords = ['商科学术', '经济学', 'Business Academic', 'Economics']
      const enterpriseKeywords = [
        '企业技能',
        '会计学（通用）',
        '会计学(通用)',
        '商业决策',
        '数字表格',
        '销售管理',
        '国际商业（通用）',
        '市场营销',
        '数字营销',
        '数据分析',
        '组织管理',
        '组织领导力',
        '快速消费品行业管理',
        'Enterprise Skills',
        'Accounting',
        'Business Decision',
        'Spreadsheet',
        'Sales Management'
      ]
      const schoolYearText = this.schoolYear ? `${this.schoolYear} ` : ''

      if (academicKeywords.some((name) => competitionText.indexOf(name) !== -1)) {
        return `${schoolYearText}Collegiate "Business Academic" Competition China`
      }
      if (enterpriseKeywords.some((name) => competitionText.indexOf(name) !== -1)) {
        return `${schoolYearText}Collegiate "Enterprise Skills" Competition China`
      }

      return item.project_nameEn || item.project_name || ''
    },
    getAwardLabelEn(item) {
      if (!item) return ''
      const dataAwardLabelEn = item.award_name_en ||
        item.award_lable_en ||
        item.award_lableEn ||
        item.awardLabelEn
      if (dataAwardLabelEn) return dataAwardLabelEn

      const awardText = [
        item.award_show_lable,
        item.award_lableEn,
        item.award_lable_en,
        item.award_name_en,
        item.award_lable,
        item.award_label
      ].filter((name) => name).join(' ')
      const awardMap = [
        { keywords: ['一等奖', 'First Prize'], label: 'National First Prize' },
        { keywords: ['二等奖', 'Second Prize'], label: 'National Second Prize' },
        { keywords: ['三等奖', 'Third Prize'], label: 'National Third Prize' },
        { keywords: ['优秀奖', 'Excellence Award', 'Excellence'], label: 'National Excellence Award' }
      ]
      const award = awardMap.find((awardItem) => awardItem.keywords.some((name) => awardText.indexOf(name) !== -1))

      return award ? award.label : (item.award_lableEn || item.award_show_lable || '')
    },
    getAccountNameEn(item) {
      if (!item || !item.account) return ''
      return item.account.account_nameEN && item.account.account_nameEN !== ''
        ? item.account.account_nameEN
        : item.account.account_name
    },
    isLongCertificateText(text, maxLength) {
      return String(text || '').length > maxLength
    },
    getCertificateFileName(item, index, lang) {
      const studentName = this.getCertificateStudentName(item)
      const eventName = item && item.application_event ? item.application_event : `certificate-${index + 1}`
      return `${studentName || ('student-' + (index + 1))}-${eventName}-${lang}`
    },
    getCertificateStudentName(item) {
      if (!item || !item.student) return ''
      const student = item.student
      if (student.student_lastName || student.student_givenName) {
        return `${student.student_lastName || ''}${student.student_givenName || ''}`
      }
      return student.student_email || ''
    },

    formatStudentName(student){
        if(student.student_lastName_pinyin && student.student_lastName_pinyin != '' && student.student_givenName_pinyin && student.student_givenName_pinyin !=''){
          return this.upfirstName(student.student_givenName_pinyin)  +' '+ this.upfirstName(student.student_lastName_pinyin)
        }
        return this.upfirstName(student.student_lastName) +' '+ this.upfirstName(student.student_givenName)
    },
    formatIssueDate(dateStr) {
        if (!dateStr) return '';
        try {
            const date = new Date(dateStr);
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const day = date.getDate();
            return `${year}年${month}月${day}日`;
        } catch (e) {
            return dateStr;
        }
    },
    formatIssueDateEnglish(dateStr) {
        if (!dateStr) return '';
        try {
            const date = new Date(dateStr);
            const months = ['January', 'February', 'March', 'April', 'May', 'June', 
                           'July', 'August', 'September', 'October', 'November', 'December'];
            const month = months[date.getMonth()];
            const day = date.getDate();
            const year = date.getFullYear();
            return `${month} ${day}, ${year}`;
        } catch (e) {
            return dateStr;
        }
    },

    fetchData () {
      this.getTargetStudentIds().then((studentIds) => {
        const awardRequests = studentIds.map((studentId) => getStudentAwards(getProjectCode(), studentId))
        Promise.all(awardRequests).then((responses) => {
          const awards = []
          responses.forEach((res) => {
            if (res.data.code === 0) {
              awards.push.apply(awards, res.data.data || [])
            }
          })
          this.total_awards = awards.filter(
            (item) => item.award_type === 'personal total' || item.award_type === ''
          )
          this.event_awards = awards.filter(
            (item) => item.award_type === 'event rank' || item.award_type === 'event team rank' || item.award_type === 'personal total'
          )
        })

        const transcriptRequests = studentIds.map((studentId) => getStudentTranscripts(getProjectCode(), studentId))
        Promise.all(transcriptRequests).then((responses) => {
          const transcripts = []
          responses.forEach((res) => {
            if (res.data.code === 0) {
              transcripts.push.apply(transcripts, res.data.data || [])
            }
          })
          this.transcripts = transcripts
        })
      })
    },
    getTargetStudentIds () {
      if (this.$route.query.teacher_all) {
        return getEducatorAwardStudents(getProjectCode(), getUserId()).then((res) => {
          if (res.data.code === 0) {
            return (res.data.data || []).map((student) => student.student_id)
          }
          this.$message.error(res.data.msg || '学生列表加载失败')
          return []
        })
      }
      if (this.$route.query.student_ids) {
        return Promise.resolve(String(this.$route.query.student_ids).split(',').filter((id) => id))
      }
      return Promise.resolve([this.$route.query.student_id || getUserId()])
    },
    formatCreateTime(create_time) {
      var time = JSON.parse(create_time) * 1000
      var temp_date = new Date(time)
      return formatDate(temp_date, 'yyyy/MM/dd')
    },
    rank (number) {
      var tail = number.toString().charAt(number.toString().length-1,1)
      if (tail === '1' && number !== 11) {
        return "st";
      } else if (tail === '2' && number !== 12) {
        return "nd";
      } else if (tail === '3' && number !== 13) {
        return "rd";
      } else {
        return "th";
      }
    },
    upfirstName (name) {
        if (name) {
            const transferName = name.toLowerCase()
      return transferName.charAt(0).toUpperCase() + transferName.slice(1)     
        }else{
            return name
        }
      
    },
    exportPDF (id) {
      const selector = id === 'showTranscriptEng' ? '.certContainerFelcEng' : '.certContainerFelc'
      const elements = document.querySelectorAll(`#${id} ${selector}`)
      const label = id === 'showTranscriptEng' ? '英文证书' : '中文证书'

      if (elements.length === 0) {
        this.$message.warning('暂无可导出的证书')
        return
      }

      const loading = this.$loading({
        lock: true,
        text: '正在生成文件',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.6)'
      })

      const options = { orientation: 'portrait', scale: 2, quality: 0.98 }
      const task = this.isBatchExport
        ? downloadPdfZipForElements(
          elements,
          (element, index) => element.dataset.fileName || `${label}-${index + 1}`,
          `${this.project_code}-${label}`,
          options
        )
        : downloadPdfForElements(
          elements,
          sanitizeFileName(elements[0].dataset.fileName || label),
          options
        )

      task.catch(() => {
        this.$message.error('文件生成失败，请稍后重试')
      }).finally(() => {
        loading.close()
      })
    }
  }
}
</script>

<style lang="scss">
@font-face {
    font-family: 'aleo-bold';
    src: url('../../assets/font/aleo-bold.ttf');
}
@font-face {
    font-family: 'Aleo-Bold-2';
    src: url('../../assets/font/Aleo-Bold-2.otf');
}
@font-face {
    font-family: 'Aleo-Italic-4';
    src: url('../../assets/font/Aleo-Italic-4.otf');
}
@font-face {
    font-family: 'Aleo-Light-5';
    src: url('../../assets/font/Aleo-Light-5.otf');
}
@font-face {
    font-family: 'Aleo-Regular-7';
    src: url('../../assets/font/Aleo-Regular-7.otf');
}
.certContainer {
  position: relative;
  color: rgb(42, 70, 154);
  .model {
    width: 297mm;
    height: 200.7mm;
  }
  .event {
    position: absolute;
    font-size: 28px;
    top: 430px;
    left: 116px;
    font-weight: 500;
  }
  .ziZm{
    position: absolute;
    font-size: 18px;
    top: 220px;
    left: 116px;
    font-weight: 350;
    color: black;
  }
  .rhZm{
    position: absolute;
    font-size: 18px;
    top: 390px;
    left: 116px;
    font-weight: 350;
    color: black;
  }
  .award {
    position: absolute;
    font-size: 28px;
    top: 525px;
    left: 250px;
    font-weight: 500;
  }
  .projectName{
    position: absolute;
    font-size: 28px;
    top: 480px;
    left: 250px;
    font-weight: 500;
  }
  .awardPh{
    position: absolute;
    font-size: 18px;
    top: 565px;
    left: 250px;
    font-weight: 400;
  }
   
  .tefaLab{
    position: absolute;
    font-size: 18px;
    top: 615px;
    left: 116px;
    font-weight: 350;
    color: black;
  }
  .timeLab{
    position: absolute;
    font-size: 18px;
    top: 655px;
    left: 116px;
    font-weight: 350;
    color: black;
  }
  .student {
    position: absolute;
    top: 300px;
    left: 116px;
    font-size: 35px;
    // font-style: italic;
    font-weight: 600;
    .name {
      margin-right: 40px;
    }
  }
  .email{
    position: absolute;
    top: 350px;
    left: 116px;
    font-size: 20px;
    // font-style: italic;
    font-weight: 350;
  }
  .school {
    position: absolute;
    top: 260px;
    left: 116px;
    font-size: 23px;
    font-weight: 350;
  }
  .saiquImg{
    position: absolute;
    top: 480px;
    left: 116px;
    width: 120px;
    height: 110px;
    // background-color:  white;
  }
}
.certContainer1{
    position: relative;
    color: white;
    .model{
        width: 365.28mm;
        height: 205.47mm;
        z-index: -10;   
    }
    .event{
        position: absolute;
        font-size: 70px;
        top: 100px;
        left: 86px;
        font-weight: 300;
        width: 600px;
    }
    .award{
        position: absolute;
        font-size: 90px;
        top: 300px;
        left: 86px;
        font-weight: 600;
    }
    .student{
        position: absolute;
        width: 600px;
        top: 460px;
        left: 86px;
        font-size: 40px;
        font-style: italic;
        font-weight: 300;
        .name{
            margin-right: 40px;
            word-wrap: none;
        }
    }
    .school{
        position: absolute;
        top: 570px;
        left: 86px;
        font-size: 30px;
        font-weight: 300;
    }
}
.certContainer4{
  position: relative;
  color: rgb(42, 70, 154);
  .model {
    width: 297mm;
    height: 208.7mm;
  }
  .event {
    position: absolute;
    font-size: 28px;
    top: 430px;
    left: 116px;
    font-weight: 500;
  }
  .ziZm{
    position: absolute;
    font-size: 18px;
    top: 220px;
    left: 116px;
    font-weight: 350;
    color: black;
  }
  .rhZm{
    position: absolute;
    font-size: 18px;
    top: 390px;
    left: 116px;
    font-weight: 350;
    color: black;
  }
  .award {
    position: absolute;
    font-size: 28px;
    top: 525px;
    left: 250px;
    font-weight: 500;
  }
  .projectName{
    position: absolute;
    font-size: 28px;
    top: 480px;
    left: 250px;
    font-weight: 500;
  }
  .awardPh{
    position: absolute;
    font-size: 18px;
    top: 565px;
    left: 250px;
    font-weight: 400;
  }

  .tefaLab{
    position: absolute;
    font-size: 18px;
    top: 615px;
    left: 116px;
    font-weight: 350;
    color: black;
  }
  .timeLab{
    position: absolute;
    font-size: 18px;
    top: 655px;
    left: 116px;
    font-weight: 350;
    color: black;
  }
  .student {
    position: absolute;
    top: 300px;
    left: 116px;
    font-size: 35px;
    // font-style: italic;
    font-weight: 600;
    .name {
      margin-right: 40px;
    }
  }
  .email{
    position: absolute;
    top: 350px;
    left: 116px;
    font-size: 20px;
    // font-style: italic;
    font-weight: 350;
  }
  .school {
    position: absolute;
    top: 260px;
    left: 116px;
    font-size: 23px;
    font-weight: 350;
  }
  .saiquImg{
    position: absolute;
    top: 480px;
    left: 116px;
    width: 120px;
    height: 110px;
    // background-color:  white;
  }
}
.certContainerFelc{
  position: relative;
  width: 210mm;
  height: 297mm;
  overflow: hidden;
  background: #fff;
  color: #333;
  font-family: 'SourceHanSansCN-Bold';

  .model {
    width: 210mm;
    height: 297mm;
    z-index: 0;
    display: block;
  }
  .event {
    position: absolute;
    font-size: 25px;
    top: 550px;
    // left: 116px;
    font-weight: 600;
    text-align: center;
    width: 210mm;
  }
 
  .award {
    position: absolute;
    font-size: 38px;
    top: 645px;
    left: 105mm;
    font-weight: 500;
    color: #233C85;
  }
  .projectName{
    position: absolute;
    font-size: 20px;
    top: 505px;
    // left: 250px;
    text-align: center;
    width: 210mm;
    font-weight: 600;
  }
  .awardPh{
    font-family: 'SourceHanSansCN-Normal';
    position: absolute;
    font-size: 18px;
    top: 700px;
    left: 105mm;
    color: gray;
    font-weight: 400;
  }

  .tefaLab{
    position: absolute;
    font-size: 20px;
    top: 460px;
    font-weight: 600;
    text-align: center;
    width: 210mm;
    color: black;
  }
  .timeLab{
    font-family: 'SourceHanSansCN-Normal';
    position: absolute;
    font-size: 18px;
    top: 812px;
    left: 105mm;
    font-weight: 350;
    color: black;
  }
  .student {
    position: absolute;
    top: 330px;
    // left: 116px;
    text-align: center;
    font-size: 35px;
    width: 210mm;
    // background-color: #003262;
    // font-style: italic;
    font-weight: 600;
    .name {
      // margin-right: 40px;
    }
  }
  .email{
    font-family: 'SourceHanSansCN-Normal';
    position: absolute;
    top: 388px;
    // left: 116px;
    width: 210mm;
    text-align: center;
    font-size: 20px;
    // font-style: italic;
    font-weight: 350;
  }
  .school {
    position: absolute;
    font-weight: 600;
    width: 210mm;
    text-align: center;
    top: 295px;
    // left: 116px;
    font-size: 23px;
    font-weight: 450;
  }
  .saiquImg{
    position: absolute;
    top: 620px;
    left: 250px;
    width: 140px;
    height: 130px;
    // background-color:  white;
  }
}

.certContainerFelcEng{
  position: relative;
  width: 210mm;
  height: 297mm;
  overflow: hidden;
  background: #fff;
  color: #333;
  font-family: 'SourceHanSansCN-Bold';

  .model {
    width: 210mm;
    height: 297mm;
    z-index: 0;
    display: block;
  }
  .event {
    position: absolute;
    font-size: 20px;
    top: 550px;
    // left: 116px;
    font-weight: 600;
    text-align: center;
    width: 210mm;
  }
 
  .award {
    position: absolute;
    font-size: 30px;
    top: 645px;
    left: 85mm;
    font-weight: 500;
    color: #233C85;
  }
  .projectName{
    position: absolute;
    font-size: 20px;
    top: 505px;
    // left: 250px;
    text-align: center;
    width: 210mm;
    font-weight: 600;
  }
  .awardPh{
    font-family: 'SourceHanSansCN-Normal';
    position: absolute;
    font-size: 18px;
    top: 700px;
    left: 105mm;
    color: gray;
    font-weight: 400;
  }

  .tefaLab{
    position: absolute;
    font-size: 20px;
    top: 460px;
    font-weight: 600;
    text-align: center;
    width: 210mm;
    color: black;
  }
  .timeLab{
    font-family: 'SourceHanSansCN-Normal';
    position: absolute;
    font-size: 18px;
    top: 812px;
    left: 105mm;
    font-weight: 350;
    color: black;
  }
  .recipientInfo {
    position: absolute;
    top: 292px;
    left: 17mm;
    width: 176mm;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    text-align: center;
  }
  .recipientInfo .school,
  .recipientInfo .student,
  .recipientInfo .email {
    position: static;
    width: 100%;
    text-align: center;
  }
  .recipientInfo .school {
    font-size: 23px;
    line-height: 1.18;
    font-weight: 600;
    max-height: 54px;
    overflow: hidden;
    overflow-wrap: break-word;
  }
  .recipientInfo .school.is-long {
    font-size: 20px;
    line-height: 1.16;
  }
  .recipientInfo .student {
    font-size: 32px;
    line-height: 1.05;
    font-weight: 600;
  }
  .recipientInfo .student.is-long {
    font-size: 28px;
  }
  .recipientInfo .email {
    font-family: 'SourceHanSansCN-Normal';
    margin-top: 8px;
    font-size: 19px;
    line-height: 1.1;
    font-weight: 350;
  }
  .student {
    position: absolute;
    top: 330px;
    // left: 116px;
    text-align: center;
    font-size: 35px;
    width: 210mm;
    // background-color: #003262;
    // font-style: italic;
    font-weight: 600;
    .name {
      // margin-right: 40px;
    }
  }
  .email{
    font-family: 'SourceHanSansCN-Normal';
    position: absolute;
    top: 390px;
    // left: 116px;
    width: 210mm;
    text-align: center;
    font-size: 20px;
    // font-style: italic;
    font-weight: 350;
  }
  .school {
    position: absolute;
    font-weight: 600;
    width: 210mm;
    text-align: center;
    top: 295px;
    // left: 116px;
    font-size: 23px;
    font-weight: 450;
  }
  .saiquImg{
    position: absolute;
    top: 620px;
    left: 150px;
    width: 140px;
    height: 130px;
    // background-color:  white;
  }
}
.transcriptContainer{
    position: relative;
    margin-bottom:-4px;
    .model_p{
        width: 210mm;
        height: 295mm;
        z-index: 0;
    }
    .name{
        position: absolute;
        top: 326px;
        left: 38px;
        font-size: 30px;
    
    }
    .info{
        position: absolute;
        top:384px;
        left: 38px;
        font-size: 15px;
        .tag{
            font-family: 'Aleo-Bold-2';
        }
        .content{
            font-family: 'Aleo-Regular-7';
        }
    }
    .score{
        position: absolute;
        top: 500px;
        width:320px;
        
        left:55px;
        font-size: 12px;
        font-family: 'Aleo-Regular-7';
        span{
            font-family: 'Aleo-Bold-2';
            font-size: 14px;
        }
        .title{
            font-family: 'aleo-bold';
        }
    }
    .score1{
        position: absolute;
        top: 500px;
        width:320px;
        left:434px;
        font-size: 15px;
        font-family: 'Aleo-Regular-7';
        span{
            font-family: 'Aleo-Bold-2';
            font-size: 17px;
        }
        .title{
            font-family: 'aleo-bold';
        }
    }
    .time1{
        position: absolute;
        top: 890px;
        width:320px;
        left:40px;
        font-size: 18px;
        font-weight: 600;
        color: #2A358A;
        // font-family: 'Aleo-Regular-7';
        // span{
        //     font-family: 'Aleo-Bold-2';
        //     font-size: 14px;
        // }
        // .title{
        //     font-family: 'aleo-bold';
        // }
    }
}

</style>
